export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff15c32185a7e528b9df202bc03d4984c86bf1991&name=fetchTypeahead!'